@if(true) {
<div class="bg-col-5 bg-col-w-s bg-col-w-m p-t-14 p-t-18-x p-t-18-l"
     [ngClass]="{'page-content' : !basket.qty}"
     cy-basketView>
    <div class="wrap p-t p-t-12-x p-t-12-l">
        <!-- continue shopping / S -->
        <a *ifSize="'SM'"
           (click)="goBack()"
           class="inline-block m-b-9 z-3">
            <i class="icon-chevron-left fs-3 m-r-3 inline-flex"></i>
            <span class="p2">{{'Continue shopping' | translate}}</span>
        </a>

        <div class="c-1"
             *ifSize="'XL'"></div>

        <!-- empty basket -->
        @if (!basket.qty) {
        <div class="m-t-6 ta-center"
             cy-basketEmpty>
            <p class="p3">{{'Your bag is empty' | translate}}</p>
            <div class="m-t">
                <a [routerLink]="'/' | lastCategoryPath"
                   class="button">{{'Continue shopping' | translate}}</a>
            </div>
            <icms-outlet-block class="w-12"
                               variant="basket-empty"
                               name="Empty Basket">
            </icms-outlet-block>
        </div>
        }

        <!-- left side -->
        <div class="c-6 c-12-s c-12-m m-b-0 p-l p-l-0-s p-l-0-m">
            @for (basketSplit of splitedBasket; track $index; let isLast = $last) {
            @if (basketSplit?.qty) {
            <div class="p-a-8 p-a-0-m p-a-0-s"
                 [class.m-b-3]="!isLast"
                 sizeClass="SM: b-b b-col-42"
                 [ngClass]="{'bg-col-w' : basketSplit.qty}">
                <p class="w-12 p-t-3 p-b-3 p1">{{'Items in the shopping bag are not reserved' | translate}}</p>
                <!-- title -->
                <div class="p-b-4 p-b-6-s p-b-6-m m-t-3-s flex flex-justify-left-s flex-bottom"
                     [class.p-b-6-s]="!isLast">
                    <span class="p-r-3 p-r-2-s p-r-2-m"
                          sizeClass="SM: s1, LX: h3">
                        {{'% Bag' | translate : basketSplit.name === 'In-Stock' ? 'Shopping' : basketSplit.name}}
                    </span>
                    <span class="flex-grow"></span>
                    @if (basket.qty) {
                    <div sizeClass="SM:p2 col-12,!S:p1">
                        <flush-basket-button class="m-r-2"
                                             *ifTradeStore></flush-basket-button>
                        {{ (basketSplit.qty === 1 ? '% item' : '% items') | translate : basketSplit.qty}}
                    </div>
                    }
                </div>
                <!-- free delivery notice -->
                <ng-container *ifStore="'uk'">
                    @if (basket.freeShippingRules.length > 0) {
                    <div class="bg-col-51 col-6">
                        @for (rule of basket.freeShippingRules; track $index) {
                        <div class="w-12 p-t-3 p-b-3 inline-block left pos-relative p1 center">
                            @if (rule.value > basket.data.totals?.subtotal) {
                            {{' You are ' | translate}}
                            <price class="price"
                                   [value]="rule.value - basket.data.totals?.subtotal">
                            </price>
                            {{ ' away from Free %' | translate : rule.name }}
                            }
                            @if (rule.value <= basket.data.totals?.subtotal)
                               {
                               {{ 'You have Free %'
                               |
                               translate
                               :
                               rule.name
                               }}
                               }
                               </div>
                                }
                        </div>
                        }
                </ng-container>
                <ecologi-banner-block class="w-12 m-t-2"
                                      [numberOfTrees]="ecologiTreeNumber"></ecologi-banner-block>
                <ng-container *ifSize="'SM'">
                    @if (showSurchargeInfo) {
                    <div class="m-t">
                        <surcharge-info-block [variant]="'basket'"></surcharge-info-block>
                    </div>
                    }
                </ng-container>
                <!-- items -->
                <ul>
                    @for (item of basketSplit.items | orderBy : ['data.added_at'] : ['desc']; track $index) {
                    <li>
                        <basket-item class="w-12 p-t p-b b-b b-col-42"
                                     [item]="item"
                                     cy-basketProd></basket-item>
                    </li>
                    }
                    <li class="w-12 m-t-7 m-t-12-s m-b-4-s m-b-6-m inline-flex flex-justify-between">
                        <span class="p1">{{'% Subtotal' | translate : basketSplit.name }} </span>
                        <price class="price p1"
                               precision="2"
                               [value]="basketSplit.subtotal"></price>
                    </li>
                </ul>
                <ng-container *ifSize="'XL'">
                    @if (showSurchargeInfo) {
                    <div class="m-t">
                        <surcharge-info-block [variant]="'basket'"></surcharge-info-block>
                    </div>
                    }
                </ng-container>
            </div>
            }
            }
            @if (basket.qty) {
            <icms-outlet-block class="w-12"
                               variant="basket-left-side"
                               name="Basket Left">
            </icms-outlet-block>
            }
        </div>

        <!-- right side -->
        @if (basket.qty) {
        <div class="w-4 w-12-s w-12-m m-t-6-s m-t-6-m">
            <div class="bg-col-w p-a-8 p-a-0-s p-a-0-m p-t-6">
                <!-- title -->
                <div *ifSize="'LX'"
                     class="m-b left">
                    <span class="h3 p-r-6">{{'Order summary' | translate}}</span>
                </div>
                <div class="m-b">
                    <!-- totals -->
                    <basket-view-totals [showSurchargeInfo]="showSurchargeInfo"
                                        class="block"></basket-view-totals>
                    <!-- mention me -->
                    <mention-me-wrapper *ifStore="['uk', 'us', 'ca', 'au']"
                                        class="block m-t-4"
                                        mmid="mm8424c5bb"
                                        place="refereefind"
                                        situation="cart"
                                        implementation="link"></mention-me-wrapper>
                </div>
                <div class="w-12 m-b m-b-2-s m-b-2-m">
                    @if(basket.totals?.grand_total > 0) {
                    <div class="p-b-2 p-t-2 p-r-1">
                        <paypal-pay-in-three-message [mode]="'basket'"
                                                     [amount]="basket.totals?.grand_total.toFixed(2)"></paypal-pay-in-three-message>
                    </div>
                    }
                    <!-- coupon form -->
                    <coupon-form></coupon-form>
                    <giftcards-form *ifNotTradeStore
                                    class="block m-t-3"></giftcards-form>
                    <div *ifSize="'LX'"
                         class="ta-center m-t">
                        <!-- go to checkout -->
                        <a [routerLink]="addonsAvailable ? '/add-ons' : '/checkout'"
                           [class.is-disabled]="warning || addonsAvailable === null"
                           cy-checkoutProceed
                           class="w-12 button">
                            <span class="button__body p2">{{'Checkout securely' | translate}}</span>
                        </a>
                        @if (basket.isSalable) {
                        <stripe-express-payment-request-button
                                                               class="block m-t-2 hiddeExpressPayments"></stripe-express-payment-request-button>
                        <paypal-express-button
                                               class="block m-t-2 pos-relative z-0 m-b--1 hiddeExpressPayments"></paypal-express-button>
                        }
                        <!-- out of stock products alert -->
                        @if (warning) {
                        <p class="m-t-2 col-2 c1">
                            {{warning | translate}}
                        </p>
                        }
                        @if (basket.weight) {
                        <p class="p2 m-t-3">
                            <span>{{'Total weight of items in your basket is %kgs' | translate : basket.weight }}</span>
                        </p>
                        }
                        <!-- continue shopping -->
                        <button (click)="goBack()"
                                class="w-12 button-1 m-b m-t-2">
                            <span class="button__body">{{'Continue shopping' | translate}}</span>
                        </button>
                    </div>
                </div>
                <!-- accepted payments / X, L -->
                <payments-methods-logos-block *ifSize="'LX'"></payments-methods-logos-block>
                <bottom-panel *ifSize="'SM'"
                              [bottomPanelRestricted]="['footer']"
                              [elementHeight]="'bottom-panel'">
                    <!-- go to checkout -->
                    <a [routerLink]="addonsAvailable ? '/add-ons' : '/checkout'"
                       [class.is-disabled]="!isSalable || addonsAvailable === null"
                       cy-checkoutProceed
                       class="w-12 button">
                        <span class="button__body p2">{{'Checkout securely' | translate}}</span>
                    </a>
                    <!-- mobile checkout -->
                    @if (basket.isSalable) {
                    <stripe-express-payment-request-button
                                                           class="block m-t-2 hiddeExpressPayments"></stripe-express-payment-request-button>
                    <paypal-express-button
                                           class="block m-t-2 pos-relative z-0 m-b--1 hiddeExpressPayments"></paypal-express-button>
                    }
                    <!-- continue shopping -->
                    <button (click)="goBack()"
                            class="w-12 button-1 m-b m-t-2">
                        <span class="button__body">{{'Continue shopping' | translate}}</span>
                    </button>
                    <!-- out of stock products alert -->
                    @if (warning) {
                    <p class="m-t-2 col-2 c1">{{warning | translate}}</p>
                    }
                </bottom-panel>
            </div>
            <icms-outlet-block class="w-12"
                               variant="basket-right-side"
                               name="Basket Right">
            </icms-outlet-block>
        </div>
        }
        <div class="c-1"
             *ifSize="'XL'"></div>
        @if (basket.qty) {
        <icms-outlet-block class="w-12"
                           variant="basket-bottom"
                           name="Basket Bottom">
        </icms-outlet-block>
        }
    </div>
</div>
}